<template>
  <div class="drag"
       @mousedown="start($event)"
       @touchstart="start($event)"
       @mousemove="move($event)"
       @touchmove="move($event)"
       @mouseup="end($event)"
       @touchend="end($event)"
       :style="style">
    <div class="delete"
         @click="deleteDraggable"
         v-if="!preview"
         :style="{'right': signType === 7 ? '0' : '-4px'}">
      <van-icon name="cross" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      moveDiv: null,
      position: { x: 0, y: 0 }, // 鼠标点击的x轴和y轴的距离
      nx: '', // 鼠标当前距离元素的左侧距离
      ny: '', // 鼠标当前距离元素的顶部距离
      dx: '', // 元素距离左侧的距离
      dy: '', // 元素距离顶部的距离
      xPum: '', // 元素移动的x轴距离
      yPum: '', // 元素移动的y轴距离,
      clientWidth: 0
    }
  },
  props: {
    w: {
      type: Number,
      default () {
        return 0
      }
    },
    h: {
      type: Number,
      default () {
        return 0
      }
    },
    x: {
      type: Number,
      default () {
        return 0
      }
    },
    y: {
      type: Number,
      default () {
        return 0
      }
    },
    picUrl: {
      type: String,
      default () {
        return ''
      }
    },
    index: {
      type: Number,
      default () {
        return ''
      }
    },
    parentIndex: {
      type: Number,
      default () {
        return ''
      }
    },
    signType: {
      type: Number,
      default () {
        return 1
      }
    },
    preview: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  computed: {
    ...mapState({
      imgHeight: 'imgHeight',
      urlList: 'urlList'
    }),
    style () {
      let params = {
        'width': this.w + 'px',
        'height': this.h + 'px',
        'left': this.signType === 7 ? '0' : this.x + 'px',
        'right': '0px',
        'top': this.y + 'px',
        'background-image': 'url(' + this.picUrl + ')'
      }
      if (this.preview) {
        params['z-index'] = 1
      }
      if (this.signType === 7) {
        params.width = this.w / this.urlList + 'px'
        params.backgroundPosition = (this.w / this.urlList) * this.parentIndex * -1 + 'px 100%'
        params.left = 'auto'
      }
      return params
    }
  },
  methods: {
    start (e) {
      // 如果touches存在就说明是移动端
      // 否则为pc端直接获取事件源对象
      let touch = e.touches ? e.touches[0] : e
      this.position.x = touch.clientX
      this.position.y = touch.clientY
      this.dx = e.target.offsetLeft
      this.dy = e.target.offsetTop
      this.clientWidth = document.documentElement.clientWidth
    },
    deleteDraggable () {
      this.$emit('deleteSigner', this.parentIndex, this.index)
    },
    move (e) {
      if (this.preview) return
      let touch = e.touches ? e.touches[0] : e
      this.nx = touch.clientX - this.position.x
      this.ny = touch.clientY - this.position.y
      this.xPum = this.dx + this.nx
      this.yPum = this.dy + this.ny
      this.xPum = this.xPum < 0 ? 0 : this.xPum
      this.yPum = this.yPum < 0 ? 0 : this.yPum
      if (this.yPum > this.imgHeight - e.target.offsetHeight) {
        this.yPum = this.imgHeight - e.target.offsetHeight
      }
      if (this.xPum > this.clientWidth - e.target.offsetWidth) {
        this.xPum = this.clientWidth - e.target.offsetWidth
      }
      if (e.target.className !== 'drag') return
      e.target.style.top = this.yPum + 'px'
      document.addEventListener('touchmove', function () {
        e.preventDefault()
      }, false)
      if (e.preventDefault) {
        e.preventDefault()
      } else {
        window.event.returnValue = false
      }
      this.$emit('changeStyle', this.parentIndex, this.index, this.xPum, this.yPum)
      if (this.signType === 7) {
        return
      }
      e.target.style.left = this.xPum + 'px'
      console.log(this.imgHeight)
    },
    end (e) {
      console.log(e)
      let oWidth = e.target.offsetWidth // Element Width
      let oWrapWidth = e.target.parentNode.offsetWidth // Parent Element Width
      let oWrprapHeight = e.target.parentNode.offsetHeight // Parent Element Height
      let sumWidth = e.target.offsetLeft + oWidth // Element Left + Element Width
      let sumHeight = e.target.offsetTop + e.target.offsetHeight // Element Top + Element Height
      // The Limit Deal
      if (e.target.offsetLeft < 0) {
        e.target.style.left = 0
      } else if (sumWidth > oWrapWidth) {
        e.target.style.left = oWrapWidth - oWidth + 'px'
      } else if (e.target.offsetTop < 0) {
        e.target.style.top = 0
      } else if (sumHeight > oWrprapHeight) {
        e.target.style.top = oWrprapHeight - e.target.offsetHeight + 'px'
      }
      this.$emit('showModal', true)
      document.onmousemove = null
      document.onmouseup = null
    }
  },
  mounted () {
  }
}
</script>

<style lang="less">
.drag {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  font-size: 12px;
  background-size: cover;
  border: 1px dashed #276ef9;
  background-repeat: no-repeat;
  z-index: 99;
  .delete {
    width: 16px;
    height: 16px;
    position: absolute;
    right: -4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    top: -5px;
  }
}
</style>
